const GEO_PERMISSION_STATUS = Object.freeze({
  prompt: 'prompt',
  denied: 'denied',
  granted: 'granted',
})

export default GEO_PERMISSION_STATUS
